import { render, staticRenderFns } from "./CondicionesUso.vue?vue&type=template&id=ecac36d2&"
import script from "./CondicionesUso.vue?vue&type=script&lang=js&"
export * from "./CondicionesUso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports